import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import LogisticWarning from '../../models/LogisticWarning'

export interface LogisticWarningListState extends PaginatedApiState {
  logisticWarnings?: LogisticWarning[]
}

const LogisticWarningList = (state: LogisticWarningListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<LogisticWarningListState>('LOGISTIC_WARNING_LIST')(state, action)
  }
}

export default LogisticWarningList
